import { Component } from '@angular/core';
import { NbDialogRef } from '@nebular/theme';
import { MarketVacanciesListComponent } from '../market-vacancies-list.component';
import { DualAxisComponent } from '../../dual-axis/dual-axis.component';
import { ColDef } from '../../interfaces/colDef';
import { MarketVacancy } from '../../interfaces/market-vacancy';

@Component({
  selector: 'bst-market-filter-sheet',
  templateUrl: './market-filter-sheet.component.html',
  styleUrls: ['./market-filter-sheet.component.scss'],
  standalone: false,
})
export class MarketFilterSheetComponent {
  list: MarketVacanciesListComponent;                 // set via dialog context
  dualAxis: DualAxisComponent<MarketVacancy>;          // set via dialog context
  constructor(private ref: NbDialogRef<MarketFilterSheetComponent>) {}
  get filterableColumns(): ColDef[] {
    const d = this.dualAxis?.delegate;
    if (!d) { return []; }
    // Include sticky columns (Title, Score) too — the desktop table header lets you
    // filter those, so the mobile sheet must as well. Dedupe by name.
    const all = [...(d.stickyColumnsLeft || []), ...(d.standardColumns || []), ...(d.stickyColumnsRight || [])];
    const seen = new Set<string>();
    return all.filter(c => c.filter !== false && !seen.has(c.name) && seen.add(c.name) !== undefined);
  }
  filtered(col: ColDef): boolean { return !!this.dualAxis?.filtervalid(col); }
  openColumnFilter(col: ColDef, ev: MouseEvent): void { this.dualAxis?.filter(col, ev); }

  // Sort: card view (mobile is always card view) has no column headers, so the sheet
  // surfaces the same <bst-sort-options> list the desktop panel uses. setSort owns the
  // direction + server re-fetch. Includes sticky columns (sort key like name lives in
  // stickyColumnsLeft), matching what the desktop panel now feeds the sort picker;
  // bst-sort-options de-dupes + narrows to scalar sortable types.
  get sortColDefs(): ColDef[] {
    const d = this.dualAxis?.delegate;
    if (!d) { return []; }
    return [...(d.stickyColumnsLeft || []), ...(d.standardColumns || []), ...(d.stickyColumnsRight || [])];
  }
  get currentSort(): { col: string, dir: number } | null {
    return this.dualAxis?.delegate?.options?.sorts?.[0] || null;
  }
  applySort(col: ColDef): void { this.dualAxis?.setSort(col); }

  close(): void { this.ref.close(); }
}
